import { applyMiddleware } from "redux";
import { apiMiddleware, createStore } from "./switchless-redux-actions";
import thunk from "redux-thunk";
import reducers from "./reducers";

const middlewareParameters = [apiMiddleware, thunk];

if (process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test") {
	middlewareParameters.push(require("redux-logger").default);
}

export const store = createStore(
	reducers,
	applyMiddleware(...middlewareParameters)
);
